import * as yup from 'yup'

export const talabatApiSchema = yup.object().shape({
  // ================= AUTH =================
  authUrl: yup
    .string()
    .trim()
    .url('Invalid Auth URL')
    .required('Auth URL is required'),

  webhookAuthToken: yup
    .string()
    .trim()
    .required('Webhook Auth Token is required'),

  orderWebhookToken: yup
    .string()
    .trim()
    .required('Order Webhook Token is required'),

  // ================= API =================
  apiBaseUrl: yup
    .string()
    .trim()
    .url('Invalid API Base URL')
    .required('API Base URL is required'),

  batchSize: yup
    .number()
    .typeError('Batch size must be a number')
    .required('Batch size is required')
    .integer('Batch size must be an integer')
    .min(99, 'Batch size must be greater than 99')
    .max(50000, 'Batch size too large'),

  orderLookupWindowMinutes: yup
    .number()
    .typeError('Order lookup window must be a number')
    .required('Order lookup window is required')
    .integer('Order lookup window must be an integer')
    .min(1, 'Order lookup window must be at least 1 minute')
    .max(1440, 'Order lookup window must be at most 1440 minutes'),

  isActive: yup.boolean().required(),

  // ================= AGGREGATORS =================
  aggregators: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().required('Aggregator ID is required'),
        vendorMapKey: yup.string().required('Vendor map key is required'),
        chains: yup
          .array()
          .of(
            yup.object().shape({
              chainId: yup.string().trim().required('Chain ID is required'),
              authClientId: yup
                .string()
                .trim()
                .required('Chain auth client ID is required'),
              authClientSecret: yup
                .string()
                .trim()
                .required('Chain auth client secret is required'),
              stores: yup
                .array()
                .of(yup.string().required())
                .min(1, 'At least one store is required per chain')
                .required('At least one store is required per chain'),
            }),
          )
          .notRequired(),
      }),
    )
    .min(1, 'At least one aggregator is required')
    .required(),

  // ================= PRIORITY STORE SYNC =================
  // Empty list is valid — it just means the priority cron has nothing to do.
  priorityStores: yup.array().of(yup.string().required()).notRequired(),

  prioritySyncBatchSize: yup
    .number()
    .typeError('Priority sync batch size must be a number')
    .required('Priority sync batch size is required')
    .integer('Priority sync batch size must be an integer')
    .min(1, 'Priority sync batch size must be at least 1')
    .max(50, 'Priority sync batch size must be at most 50'),

  // ================= CRONS =================
})

export type TalabatConfigFormFields = yup.InferType<typeof talabatApiSchema>
